"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-38b31e5f"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "d-flex summary-nav-btns" };
const _hoisted_2 = {
    key: 0,
    class: "pro-label small"
};
const vue_3 = require("vue");
const FilterIcon_vue_1 = __importDefault(require("../../assets/icons/FilterIcon.vue"));
const SummaryTableConfig_vue_1 = __importDefault(require("./SummaryTableConfig.vue"));
const provider_1 = require("../../../provider/provider");
const ReadReceiptIcon_vue_1 = __importDefault(require("../../assets/icons/ReadReceiptIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryDateNavButtons',
    emits: ["open-filter-modal"],
    setup(__props, { emit: __emit }) {
        const viewModel = (0, vue_3.inject)(provider_1.dateNavViewModelInjectKey);
        const summaryTableContainer = (0, vue_3.ref)(null);
        const readReceiptBtn = (0, vue_3.ref)(null);
        const isReadReceiptActive = (0, vue_3.ref)(false);
        const emit = __emit;
        const isDWS = (0, vue_3.computed)(() => {
            return viewModel?.value.isDWS || false;
        });
        const isFilterActive = (0, vue_3.computed)(() => {
            if (!viewModel?.value) {
                return false;
            }
            const isTagActive = viewModel.value.tags.some(tag => tag.selected);
            return isTagActive || viewModel.value.workerOnly || viewModel.value.lockedOnly;
        });
        const filterClass = (0, vue_3.computed)(() => {
            return {
                'active': isFilterActive.value,
                'filter-button-with-pro-label': !viewModel?.value?.hasPro && !isDWS.value,
            };
        });
        const readMarginBtnClass = (0, vue_3.computed)(() => {
            return isReadReceiptActive.value ? 'active' : '';
        });
        function openFilterModal() {
            emit('open-filter-modal');
        }
        function handleReadReceiptClick() {
            isReadReceiptActive.value = !isReadReceiptActive.value;
            summaryTableContainer.value?.classList.toggle('read-receipt-active', isReadReceiptActive.value);
            window.localStorage.setItem('read_receipt', isReadReceiptActive.value ? 'true' : 'false');
            readReceiptBtn.value?.blur();
        }
        (0, vue_3.onMounted)(() => {
            summaryTableContainer.value = document.getElementById('summary-table-container');
            isReadReceiptActive.value = window.localStorage.getItem('read_receipt') === 'true';
            if (isReadReceiptActive.value) {
                summaryTableContainer.value?.classList.add('read-receipt-active');
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(viewModel)?.canEdit && !isDWS.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                        key: 0,
                        ref_key: "readReceiptBtn",
                        ref: readReceiptBtn,
                        class: (0, vue_2.normalizeClass)(["summary-btn read-margin-btn tooltip border-none p-0 tooltip-bottom", readMarginBtnClass.value]),
                        onClick: handleReadReceiptClick,
                        "data-tooltip": "未確認のシフトを確認"
                    }, [
                        (0, vue_2.createVNode)(ReadReceiptIcon_vue_1.default)
                    ], 2 /* CLASS */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (!isDWS.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SummaryTableConfig_vue_1.default, { key: 1 }))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                ((0, vue_2.unref)(viewModel)?.hasTag)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                        key: 2,
                        class: (0, vue_2.normalizeClass)(["filter-button summary-btn border-none", filterClass.value]),
                        onClick: openFilterModal
                    }, [
                        (0, vue_2.createVNode)(FilterIcon_vue_1.default),
                        (!(0, vue_2.unref)(viewModel)?.hasPro && !isDWS.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 2 /* CLASS */))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
